/**
 * Geo Redirect Functionality for Shopify
 *
 * This script detects user's location via IP address and shows a modal
 * asking if they want to be redirected to a localized website version.
 *
 * CONFIGURATION:
 * To customize the redirect URLs, modify the 'redirectUrls' object below.
 * Add country codes (ISO 3166-1 alpha-2) as keys and redirect URLs as values.
 *
 * Example country codes: US, CA, GB, DE, FR, JP, CN, AU, etc.
 *
 * Note: excludedCountries feature has been disabled.
 * All users will see the redirect modal regardless of their location.
 *
 * The user's choice is remembered for 'rememberChoiceDays' days using cookies.
 */

(function() {
  'use strict';

  // Configuration - MODIFY THESE VALUES AS NEEDED
  const config = {
    // Default redirect URLs for different countries
    // Format: 'COUNTRY_CODE': 'https://your-redirect-url.com'
    redirectUrls: {
      'US': 'https://lvyuan.com/',        // 美国
      'DE': 'https://yinleadertech.com/',        // 欧盟
      'JP': 'https://lvyuan.jp/',        // 日本
      'KR': 'https://lvyuan.kr/',        // 韩国
      // Add more countries as needed
    },

    // Note: excludedCountries feature is disabled
    // All users will see the redirect modal
    // excludedCountries: ['CN'], // This feature is no longer active

    // How long to remember user choice (in days)
    rememberChoiceDays: 1,

    // IP Geolocation API (free service, no API key required)
    geoApiUrl: 'https://ipapi.co/json/',

    // Modal element ID (matches the HTML in geo-redirect-modal.liquid)
    modalId: 'geo-redirect-modal',

    // Enable auto popup on page load
    // Set to false to disable auto popup, but keep manual trigger button functional
    enableAutoPopup: false,

    // Multi-language support
    languages: {
      'en': {
        title: 'Region Settings',
        message: 'We notice you might be located in',
        description: 'To provide you with a better shopping experience, would you like to visit the version of the site for your region?',
        selectionTitle: 'Or please select the region you wish to visit:',
        stayButton: 'Stay on current site',
        redirectButton: 'Redirect to local site',
        note: 'To provide a better experience, we will temporarily remember your choice. This website uses cookies to optimize your shopping experience.'
      },
      'ja': {
        title: '地域設定',
        message: 'あなたがいる場所を検出しました',
        description: 'より適切なショッピング体験を提供するために、お住まいの地域のサイトバージョンをご覧になりますか？',
        selectionTitle: 'または、アクセスしたい地域を選択してください：',
        stayButton: '現在のサイトにとどまる',
        redirectButton: '現地のサイトにリダイレクト',
        note: 'より良い体験を提供するために、選択を一時的に記憶します。このウェブサイトは、ショッピング体験を最適化するためにクッキーを使用しています。'
      },
      'ko': {
        title: '지역 설정',
        message: '귀하의 위치를 감지했습니다',
        description: '보다 적합한 쇼핑 경험을 제공하기 위해 귀하의 지역 버전 사이트를 방문하시겠습니까？',
        selectionTitle: '또는 방문하실 지역을 선택하세요：',
        stayButton: '현재 사이트에 머물기',
        redirectButton: '국내 사이트로 리디렉션',
        note: '보다 나은 경험을 제공하기 위해 선택사항을 일시적으로 기억합니다. 이 웹사이트는 쇼핑 경험을 최적화하기 위해 쿠키를 사용합니다.'
      }
    }
  };

  // Utility functions
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Get user's geolocation data
  async function getGeoData() {
    try {
      const response = await fetch(config.geoApiUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch geo data');
      }

      const data = await response.json();
      return {
        country: data.country_code || data.country,
        countryName: data.country_name,
        city: data.city,
        region: data.region,
        ip: data.ip
      };
    } catch (error) {
      console.error('Geo detection error:', error);
      return null;
    }
  }

  // Get language code based on country code
  function getLanguageCode(countryCode) {
    // Map country codes to language codes
    const countryLanguageMap = {
      'JP': 'ja',
      'KR': 'ko'
    };
    
    // Return language code or default to English
    return countryLanguageMap[countryCode] || 'en';
  }

  // Show the redirect modal
  function showRedirectModal(geoData) {
    const modal = document.getElementById(config.modalId);
    if (!modal) {
      console.error('Geo redirect modal not found');
      return;
    }

    // Get language code based on country
    const langCode = getLanguageCode(geoData.country);
    const lang = config.languages[langCode] || config.languages.en;

    // Update modal content with location info
    const locationElement = modal.querySelector('.geo-location-info');
    if (locationElement) {
      locationElement.textContent = `${geoData.countryName || geoData.country} (${geoData.city || 'Unknown city'})`;
    }

    // Update modal text content based on language
    const titleElement = modal.querySelector('.geo-modal-title');
    if (titleElement) {
      titleElement.textContent = lang.title;
    }

    const messageElement = modal.querySelector('.geo-modal-message');
    if (messageElement) {
      messageElement.innerHTML = `${lang.message} <strong class="geo-location-info">${geoData.countryName || geoData.country} (${geoData.city || 'Unknown city'})</strong>`;
    }

    const descriptionElement = modal.querySelector('.geo-modal-description');
    if (descriptionElement) {
      descriptionElement.textContent = lang.description;
    }

    const selectionTitleElement = modal.querySelector('.geo-selection-title');
    if (selectionTitleElement) {
      selectionTitleElement.textContent = lang.selectionTitle;
    }

    const stayButton = modal.querySelector('.geo-stay-btn');
    if (stayButton) {
      stayButton.textContent = lang.stayButton;
    }

    const redirectButton = modal.querySelector('.geo-redirect-btn');
    if (redirectButton) {
      redirectButton.textContent = lang.redirectButton;
    }

    const noteElement = modal.querySelector('.geo-modal-note small');
    if (noteElement) {
      noteElement.textContent = lang.note;
    }

    // Show modal
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Handle modal events
    const closeButton = modal.querySelector('.geo-modal-close');
    const countryOptions = modal.querySelectorAll('.geo-country-option');

    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    function handleStay() {
      setCookie('geo_redirect_used', 'true', config.rememberChoiceDays);
      closeModal();
    }

    function handleRedirect() {
      const redirectUrl = config.redirectUrls[geoData.country] || config.redirectUrls['US'];
      if (redirectUrl) {
        setCookie('geo_redirect_used', 'true', config.rememberChoiceDays);
        window.location.href = redirectUrl;
      } else {
        // No specific redirect URL for this country, stay on current site
        handleStay();
      }
    }

    if (stayButton) {
      stayButton.addEventListener('click', handleStay);
    }

    if (redirectButton) {
      redirectButton.addEventListener('click', handleRedirect);
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    // Handle country selection
    function handleCountrySelection(countryCode) {
      const redirectUrl = config.redirectUrls[countryCode];
      if (redirectUrl) {
        setCookie('geo_redirect_used', 'true', config.rememberChoiceDays);
        window.location.href = redirectUrl;
      } else {
        // No redirect URL for this country, stay on current site
        handleStay();
      }
    }

    countryOptions.forEach(option => {
      option.addEventListener('click', function() {
        const countryCode = this.getAttribute('data-country');
        if (countryCode) {
          handleCountrySelection(countryCode);
        }
      });
    });

    // Close on backdrop click
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });
  }

  // Check if user should see redirect modal
  function shouldShowModal(geoData) {
    // Check if user has already used the geo redirect feature
    const hasUsed = getCookie('geo_redirect_used');
    if (hasUsed === 'true') {
      return false; // User has used the feature before, don't show modal again
    }

    // Show modal for all users regardless of location
    return true;
  }

  // Manually trigger geo redirect modal
  async function showGeoRedirectModalManually() {
    try {
      // Try to get real geo data for manual trigger
      const geoData = await getGeoData();
      if (geoData) {
        console.log('Manual trigger - User location detected:', geoData);
        showRedirectModal(geoData);
      } else {
        // Fallback to mock data if geo detection fails
        console.warn('Manual trigger - Could not determine user location, using fallback');
        const mockGeoData = {
          country: 'US',
          countryName: 'United States',
          city: 'Unknown',
          ip: 'manual-trigger-fallback'
        };
        showRedirectModal(mockGeoData);
      }
    } catch (error) {
      console.error('Manual trigger geo detection error:', error);
      // Fallback to mock data on error
      const mockGeoData = {
        country: 'US',
        countryName: 'United States',
        city: 'Unknown',
        ip: 'manual-trigger-fallback'
      };
      showRedirectModal(mockGeoData);
    }
  }

  // Setup manual trigger button
  function setupManualTrigger() {
    const triggerButton = document.getElementById('geo-redirect-trigger');
    if (triggerButton) {
      triggerButton.addEventListener('click', async function(e) {
        e.preventDefault();
        await showGeoRedirectModalManually();
      });
    }
  }

  // Initialize geo redirect functionality
  async function init() {
    // Only run on main page, not in Shopify admin
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    // Setup manual trigger
    setupManualTrigger();

    // Check if auto popup is enabled
    if (!config.enableAutoPopup) {
      console.log('Geo redirect auto popup is disabled');
      return;
    }

    try {
      const geoData = await getGeoData();
      if (!geoData) {
        console.warn('Could not determine user location');
        return;
      }

      console.log('User location detected:', geoData);

      if (shouldShowModal(geoData)) {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          showRedirectModal(geoData);
        }, 1000);
      }
    } catch (error) {
      console.error('Geo redirect initialization error:', error);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();